/* eslint-disable react-hooks/exhaustive-deps */

import { useMemo } from 'react';
import useIsMobile from 'hooks/useIsMobile';
import { useRecoilValue } from 'recoil';
import { chartExpandedState, screenWidthState } from '../../states';
import { isZerohedge } from '../../util';

const useHiroUi = () => {
  const screenWidth = useRecoilValue(screenWidthState);
  const chartExpanded = useRecoilValue(chartExpandedState);
  const isMobile = useIsMobile();

  const chartFullWidth = chartExpanded || isMobile;
  const showInlineControls = useMemo(() => {
    return (
      !isZerohedge() &&
      ((chartFullWidth && screenWidth >= 610) ||
        (!chartFullWidth && screenWidth >= 1_050))
    );
  }, [chartExpanded, screenWidth, isMobile]);

  return {
    showInlineControls,
  };
};

export default useHiroUi;
